import React, { useEffect, useRef } from "react";
import { Box } from "@mui/material";
import { DisclaimerScreen } from "./DisclaimerScreen";
import { ChatInputWrapper } from "./ChatInputWrapper";
import { QuestionInputRef } from "../../../components/QuestionInput";
import i18next from "../../../i18n/i18n";
import styles from "../Chat.module.css";

interface EmptyChatStateProps {
    sessionStatus: string;
    onDisclaimerDismiss: () => void;
    showSupportLink: boolean;
    supportEnvBoard: string;
    chatInputWrapperProps: any;
    questionInputRef?: React.Ref<QuestionInputRef>;
}

export const EmptyChatState: React.FC<EmptyChatStateProps> = ({
    sessionStatus,
    onDisclaimerDismiss,
    showSupportLink,
    supportEnvBoard,
    chatInputWrapperProps,
    questionInputRef
}) => {
    const chatEmptyStateRef = useRef<HTMLDivElement>(null);
    const isClarificationVisible = sessionStatus === "initial" && Boolean(chatInputWrapperProps?.clarificationBanner);
    const shouldPinDisclaimerTop = sessionStatus === "initial";

    useEffect(() => {
        if (!isClarificationVisible || !chatEmptyStateRef.current) {
            return;
        }

        // Keep the disclaimer header visible when clarification UI increases composer height.
        chatEmptyStateRef.current.scrollTop = 0;
    }, [isClarificationVisible]);

    return (
        <div ref={chatEmptyStateRef} className={`${styles.chatEmptyState} ${shouldPinDisclaimerTop ? styles.chatEmptyStateDisclaimerPinned : ""}`.trim()}>
            <DisclaimerScreen sessionStatus={sessionStatus} onDismiss={onDisclaimerDismiss} isClarificationVisible={isClarificationVisible} />

            {sessionStatus === "active" && <h2 className={styles.emptyStateLargeTitle}>{i18next.t("chat.inputHeader")}</h2>}

            <Box
                className={`${styles.emptyStateInputSlot} ${shouldPinDisclaimerTop ? styles.emptyStateInputSlotPinned : ""}`.trim()}
                sx={{
                    width: "100%",
                    minWidth: "45%",
                    maxWidth: "1060px",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: shouldPinDisclaimerTop ? "flex-start" : "center",
                    justifyContent: "center"
                }}
            >
                <ChatInputWrapper ref={questionInputRef} {...chatInputWrapperProps} showSupportLink={showSupportLink} supportEnvBoard={supportEnvBoard} />
            </Box>
        </div>
    );
};
